import React from 'react'
import { useStaticQuery, graphql, Link as GLink } from 'gatsby'

const Link = ({ children, href }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
          }
        }
      }
    `
  )

  if (href.includes(site.siteMetadata.siteUrl)) {
    let to = href.replace(site.siteMetadata.siteUrl, '')

    return (
      <GLink to={to} className="c-link" data-datocms-noindex>
        {children}
      </GLink>
    )
  }

  return (
    <a
      href={href}
      rel="noopener noreferrer"
      target="_blank"
      className="c-link"
      data-datocms-noindex
    >
      {children}
    </a>
  )
}

export default Link
